import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-phone-input-2/lib/bootstrap.css';
import Layout from './layouts/Layout';
import { AuthContextProvider } from 'context/authContext';
import { BranchContextProvider } from 'context/BranchContext';

const App = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <BranchContextProvider>
        <AuthContextProvider>
          <Layout />
        </AuthContextProvider>
      </BranchContextProvider>
    </Router>
  );
};

export default App;
